"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.markdownToSlate = void 0;
const marked_1 = require("marked");
const htmlToSlate_1 = require("./htmlToSlate");
const types_1 = require("../types");
const markdownToSlate = (markdown) => __awaiter(void 0, void 0, void 0, function* () {
    if (!markdown || markdown.trim() === '') {
        return [{ type: types_1.SlateElementType.elementDefault, children: [{ text: '' }] }];
    }
    try {
        marked_1.marked.setOptions({
            gfm: true,
            breaks: true,
        });
        const html = yield marked_1.marked.parse(markdown);
        return (0, htmlToSlate_1.htmlToSlate)(html);
    }
    catch (error) {
        console.error('Error converting markdown to slate:', error);
        return [{ type: types_1.SlateElementType.elementDefault, children: [{ text: markdown }] }];
    }
});
exports.markdownToSlate = markdownToSlate;
